import "babel-polyfill"
import "proto-polyfill"

import Vue from 'vue'
import App from './App'
import router from './router'
import config from './config'
import {store} from './store'
import vbclass from 'vue-body-class'
import Tooltip from 'vue-directive-tooltip';
//import 'vue-directive-tooltip/css/index.css';
import VueGoodTable from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import VeeValidate from 'vee-validate';
import VuePassword from 'vue-password';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import Autocomplete from 'v-autocomplete';
import VueClipboard from 'vue-clipboard2';

import 'v-autocomplete/dist/v-autocomplete.css';

Vue.use(Autocomplete);
// Sentry for log javascript live errors
if(process.env.NODE_ENV == 'production') {
	Raven
		.config('https://978bd974e522424495922ec52ee52f81@sentry.io/291052')
		.addPlugin(RavenVue, Vue)
		.install();
}
Vue.use(VueClipboard);
Vue.use(vbclass, router);
Vue.use(Tooltip);
Vue.use(VueGoodTable);
Vue.component('VuePassword', VuePassword);

var configValidate = {
 		enableAutoClasses: true,
		errorBagName: 'errors',
		strict: true,
		classes: true,
		classNames: {
			touched: 'input--touched', // the control has been blurred
			untouched: 'input--untouched', // the control hasn't been blurred
			valid: 'input--valid', // model is valid
			invalid: 'input--invalid', // model is invalid
			pristine: 'input--pristine', // control has not been interacted with
			dirty: 'input--dirty' // control has been interacted with
		}
	};
Vue.use(VeeValidate, configValidate);

Vue.config.productionTip = false

// Global mixin for config values
Vue.mixin({
	data: function() {
		return {
			config
		}
	}
});

Vue.directive('focus', {
  inserted: function (el) {
    if (el.value == ''){
        el.focus(); }
  }
});

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	template: '<App/>',
	components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js